import { create } from 'zustand'

import { addShortcut, getShortcuts, removeShortcut, type ShortcutItem } from '@/api/services/product'

type ShortcutState = {
  shortcuts: ShortcutItem[]
  shortcutProductIds: number[]
  isLoaded: boolean
  fetchShortcuts: () => Promise<void>
  addProductShortcut: (productId: number) => Promise<boolean>
  removeProductShortcut: (productId: number) => Promise<void>
}

export const useShortcutStore = create<ShortcutState>((set, get) => ({
  shortcuts: [],
  shortcutProductIds: [],
  isLoaded: false,

  fetchShortcuts: async () => {
    try {
      const data = await getShortcuts()
      set({
        shortcuts: data,
        shortcutProductIds: data.map((s) => s.product_id),
        isLoaded: true,
      })
    } catch {
      // silent fail
    }
  },

  addProductShortcut: async (productId: number) => {
    try {
      await addShortcut(productId)
      await get().fetchShortcuts()
      return true
    } catch {
      return false
    }
  },

  removeProductShortcut: async (productId: number) => {
    // 楽観更新
    set((state) => ({
      shortcuts: state.shortcuts.filter((s) => s.product_id !== productId),
      shortcutProductIds: state.shortcutProductIds.filter((id) => id !== productId),
    }))
    try {
      await removeShortcut(productId)
    } catch {
      // rollback
      await get().fetchShortcuts()
    }
  },
}))
